
(function() {
  var module = {};
  var result = {};
  module.exports = { "ja": { "i18n": { "duration": { "seconds": "{{ seconds }}秒", "minutes": "{{ minutes }}分", "hours": "{{ hours }}時間", "hoursAndMinutes": "{{ hours }}時間{{ minutes }}分", "days": "{{ days }}日", "shortForm": { "seconds": "{{ seconds }}秒", "minutes": "{{ minutes }}分", "hours": "{{ hours }}時間", "days": "{{ days }}日", "hoursAndMinutes": "{{ hours }}時間{{ minutes }}分" } }, "dateTime": { "shortForm": { "months": { "january": "1月", "february": "2月", "march": "3月", "april": "4月", "may": "5月", "june": "6月", "july": "7月", "august": "8月", "september": "9月", "october": "10月", "november": "11月", "december": "12月" } }, "monthAndDay": "{{monthName}}{{dayNumber}}日", "monthAndYear": "{{yearNumber}}年{{monthName}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ja": "static-7.446"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.446",
    "da": "static-7.446",
    "de": "static-7.446",
    "el": "static-7.446",
    "en": "static-7.446",
    "es-mx": "static-7.446",
    "es": "static-7.446",
    "fi": "static-7.446",
    "fr": "static-7.446",
    "it": "static-7.446",
    "ja": "static-7.446",
    "ko": "static-7.446",
    "nl": "static-7.446",
    "no": "static-7.446",
    "pl": "static-7.446",
    "pt-br": "static-7.446",
    "sv": "static-7.446",
    "zh-cn": "static-7.446",
    "zh-hk": "static-7.446"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ja', {version: 'static-7.446'}); }
})();


